import React from 'react';
import PropTypes from 'prop-types';
import '../global-sass/main.scss';
import { OptionsProp } from '../PropTypes/StandardFeatureProp';

export const FeatureCategoryItems = ({ options }) => {
	return (
		<ul className="standard-feature-category-list text-muted list-unstyled list-spaced line-height-condensed mt-4 ml-2 pl-5">
			{options.map(({ description, key }) => (
				<li key={key}>{description}</li>
			))}
		</ul>
	);
};

FeatureCategoryItems.propTypes = {
	options: PropTypes.arrayOf(OptionsProp).isRequired
};
